exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#uoloaddiv35[data-v-334f5e14]{margin:20px;width:800px}#topbuttn[data-v-334f5e14]{width:800px}.shenqingdiantai123[data-v-334f5e14]{margin-top:10px}.margingbot10[data-v-334f5e14]{margin-bottom:10px}.demo-table-expand[data-v-334f5e14]{font-size:0}.demo-table-expand label[data-v-334f5e14]{width:90px;color:#99a9bf}.demo-table-expand .el-form-item[data-v-334f5e14]{margin-right:0;margin-bottom:0;width:50%}.item[data-v-334f5e14]{display:flex;height:80px}.item .left[data-v-334f5e14]{width:100px;align-items:center}.item .left img[data-v-334f5e14]{height:80px}.item .right[data-v-334f5e14]{padding-left:10px;flex:1}.item .right h4[data-v-334f5e14]{margin-top:10px}.item .right p[data-v-334f5e14]{color:#c0c4cc;text-overflow:ellipsis}.icon[data-v-334f5e14]{width:25px;height:25px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-334f5e14","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/xxxvue/diantai.vue
// module id = 271
// module chunks = 0